import { TipoAvaliacao } from './tipo-avaliacao';
import { TipoIdentificacao } from './tipo-identificacao';

export class AvaliacaoAula {
  tipoAvaliacao: TipoAvaliacao;
  tipoIdentificacao: TipoIdentificacao;
  comentario: string;
}
